import type { ReactNode } from 'react'
import { Link } from '@inertiajs/react'
import { HyrinWordmark } from '@/components/Shared/HyrinWordmark'

interface PublicHeaderProps {
  children?: ReactNode
}

export function PublicHeader({ children }: PublicHeaderProps) {
  return (
    <header className="flex h-16 items-center justify-between border-b border-border px-5 sm:px-9">
      <Link href="/" className="flex items-center gap-2">
        <HyrinWordmark />
      </Link>
      {children}
    </header>
  )
}
